import type { SecureInputsFrameConfig } from "../../types";

import { iframeUri } from "./config";

export const buildFrame = ({
  uuid,
  field,
  elementConfig: { clientToken, paymentCardId, styles },
  environment,
}: Readonly<SecureInputsFrameConfig>): HTMLIFrameElement => {
  const frame = document.createElement("iframe");

  const frameSource = new URL(
    `${iframeUri}?field=${field}&token=${clientToken}&environment=${environment}&paymentCardId=${paymentCardId}&styles=${encodeURIComponent(
      JSON.stringify(styles ?? {})
    )}`
  );

  // eslint-disable-next-line fp/no-mutation
  frameSource.hash = uuid;

  frame.setAttribute("src", frameSource.toString());
  frame.style.setProperty("border", "none");

  return frame;
};
